import React from 'react'
import { BsQuote } from 'react-icons/bs'

function About({ match }) {

    return (
        <>
            <div className='d-flex'>
                <BsQuote className='match-detail-icon' />
                <div className='match-detail-title'>About {match?.firstName} {match?.lastName}</div>
            </div>
            <div className='d-flex match-detail-info'>
                <div className='match-detail-about-btn'>ID: {match?.userId}</div>
                <div className='match-detail-about-btn'>Looking for: {match?.lookingFor}</div>
            </div>
            <div className='match-detail-info'>{match?.personalDetails?.aboutMe}</div>
        </>
    )
}

export default About